import { TicketConversation } from '../type/Ticket';
import { DateTimeHtml } from '@dokan/components';
import { __ } from '@wordpress/i18n';
import { RawHTML } from '@wordpress/element';

function ChatItem( { conversation }: { conversation: TicketConversation } ) {
    const name = conversation?.sender_name
        ? conversation?.sender_name
        : __( 'No Name', 'dokan' );
    return (
        <div className="p-4 border-b border-[#EEEEEE] flex flex-col gap-4">
            <div className="flex gap-4">
                <div className="w-[44px] h-[44px] rounded-full overflow-hidden">
                    <img src={ conversation?.sender_avatar } alt="no-image" />
                </div>
                <div className="flex flex-col gap-[4px]">
                    <span className="font-bold text-[15px]">{ name }</span>
                    <span className="text-neutral-400">
                        <DateTimeHtml date={ conversation?.date_created } />
                    </span>
                </div>
            </div>
            <div>
                <RawHTML>{ conversation?.message }</RawHTML>
            </div>
        </div>
    );
}

export default ChatItem;
